import { render, staticRenderFns } from "./CollectionPayCertificateInstallment.vue?vue&type=template&id=50240ae5&scoped=true"
import script from "./CollectionPayCertificateInstallment.vue?vue&type=script&lang=js"
export * from "./CollectionPayCertificateInstallment.vue?vue&type=script&lang=js"
import style0 from "./CollectionPayCertificateInstallment.vue?vue&type=style&index=0&id=50240ae5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50240ae5",
  null
  
)

export default component.exports